module.exports = __webpack_public_path__ + "static/media/carrots.c98c1021.png";